import AboutHero from "@/pages/about/AboutHero";
import Approach from "@/pages/about/Approach";
import WhyClosing from "@/pages/about/WhyClosing";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function AboutPage() {
  usePageMeta({
    title: "About 30 NORTH | Transportation & Logistics",
    description:
      "Learn about 30 NORTH, an Ontario transportation and logistics company built on 6+ years of hands-on logistics and supply chain experience.",
    path: "/about",
  });

  return (
    <div data-testid="about-page">
      <AboutHero />
      <Approach />
      <WhyClosing />
    </div>
  );
}
